import Dashboard from "../modules/homepage/component/ArticleSection";
import HomeHero from "../modules/homepage/component/HomeHero";

import React from "react";

const Home: React.FC = () => {
  return (
    <div className="flex flex-col ">
      <div className="relative">
        <HomeHero />
      </div>
      <Dashboard />
    </div>
  );
};

export default Home;
